var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProductHuntThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#DA552E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2982 17.9478H14.539V20.8696H12.5912V11.1304H17.2982C19.1809 11.1304 20.7069 12.6564 20.7069 14.5391C20.7069 16.4218 19.1809 17.9478 17.2982 17.9478ZM15.9999 6.26086C10.6208 6.26086 6.26074 10.621 6.26074 16C6.26074 21.379 10.6208 25.7391 15.9999 25.7391C21.3783 25.7391 25.739 21.379 25.739 16C25.739 10.621 21.3783 6.26086 15.9999 6.26086ZM17.2982 13.0783H14.539V16H17.2982C18.1054 16 18.7591 15.3456 18.7591 14.5391C18.7591 13.7326 18.1054 13.0783 17.2982 13.0783Z",
    fill: "white"
  })));
}

export default SvgProductHuntThumb;